import Drawer from '@mui/material/Drawer'
import { makeStyles } from '@material-ui/core/styles'
import styles from 'assets/jss/style-component/components/sidebarStyle.js'
import clsx from 'clsx'
import MenuPopup from 'components/MenuPopup/MenuPopup'
import PropTypes from 'prop-types'
import React from 'react'
import IconButton from '@mui/material/IconButton'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import { NavLink } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip'

const useStyles = makeStyles(styles)
const drawerWidth = 220

const useStylesDraw = makeStyles({
    drawerOpen: {
        width: drawerWidth,
        transition: 'width 0.3s ease !important',
        overflowX: 'hidden',
    },
    drawerClose: {
        width: 0,
        transition: 'width 0.3s ease !important',
        overflowX: 'hidden',
        borderRight: 'none !important',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '4px 6px 4px 4px',
        minHeight: 44,
        borderBottom: '1px solid rgba(255,255,255,0.12)',
    },
    logoArea: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        overflow: 'hidden',
        textDecoration: 'none',
        flex: 1,
        minWidth: 0,
    },
    logoImg: {
        width: 32,
        height: 32,
        borderRadius: '50%',
        border: '1px solid rgba(255,255,255,0.5)',
        flexShrink: 0,
    },
    logoText: {
        color: '#fff',
        fontSize: 12,
        fontWeight: 600,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        letterSpacing: 0.5,
    },
    closeBtn: {
        color: 'rgba(255,255,255,0.7) !important',
        width: 28,
        height: 28,
        flexShrink: 0,
        '&:hover': {
            background: 'rgba(255,255,255,0.12) !important',
            color: '#fff !important',
        },
    },
})

export default function SidebarNew(props) {
    const classes = useStyles()
    const classesDraw = useStylesDraw()
    const { color, logo, logoText, menu, submenu, submenuhijo } = props

    return (
        <Drawer
            anchor="left"
            variant="permanent"
            classes={{
                paper: clsx({
                    [classesDraw.drawerOpen]: props.open,
                    [classesDraw.drawerClose]: !props.open,
                })
            }}
            ModalProps={{ keepMounted: true }}
        >
            <div className={classes.sidebarWrapper} style={{ width: drawerWidth }}>
                {/* Header: logo + botón cerrar */}
                <div className={classesDraw.header}>
                    <NavLink to="/admin/home" className={classesDraw.logoArea}>
                        {logo && <img src={logo} alt="logo" className={classesDraw.logoImg} />}
                        <span className={classesDraw.logoText}>{logoText || ''}</span>
                    </NavLink>
                    <Tooltip title="Cerrar menú" placement="right">
                        <IconButton
                            className={classesDraw.closeBtn}
                            size="small"
                            onClick={props.handleDrawerToggle}
                        >
                            <ChevronLeftIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </div>

                {/* Items del menú */}
                <MenuPopup
                    color={color}
                    menu={menu}
                    submenu={submenu}
                    submenuhijo={submenuhijo}
                    open={props.open}
                />
            </div>
        </Drawer>
    )
}

SidebarNew.propTypes = {
    color: PropTypes.string,
    logo: PropTypes.string,
    logoText: PropTypes.string,
    menu: PropTypes.array,
    submenu: PropTypes.array,
    submenuhijo: PropTypes.array,
    handleDrawerToggle: PropTypes.func,
    open: PropTypes.bool,
}
